import type {HighlightColor} from './annotationTypes';

/** First hover waits this long; while the group stays warm, neighbors show instantly. */
export const TOOLTIP_SHOW_DELAY_MS = 400;

/**
 * Hint tooltips for the note controls: pointer-transparent from the portal root down,
 * and bounded to the viewport so the peek's scroll box can't clamp them onto the pencil.
 */
export const NOTE_TOOLTIP_PROPS = {
  showDelay: TOOLTIP_SHOW_DELAY_MS,
  className: 'pointer-events-none',
  anchoredFixedPositionProps: {
    modifiers: {preventOverflow: {boundariesElement: 'viewport'}}
  }
} as const;

export const ANNOTATION_MODE_ON_TOOLTIP = 'You cannot change answer choices in this mode.';

export const HIGHLIGHT_NAME_BY_COLOR: Record<HighlightColor, string> = {
  yellow: 'student-annotations-yellow',
  blue: 'student-annotations-blue',
  pink: 'student-annotations-pink'
};

export const UNDERLINE_HIGHLIGHT_NAME = 'student-annotations-underline';

// Every registered highlight name: one per color plus the single underline style.
export const ALL_HIGHLIGHT_NAMES = [
  ...Object.values(HIGHLIGHT_NAME_BY_COLOR),
  UNDERLINE_HIGHLIGHT_NAME
];

/** A mark's hover shade, painted over the mark itself while a click would open its editor. */
export const hoverHighlightNameOf = (name: string): string => `${name}-hover`;

/** A mark's pressed shade, which takes over from the hover shade while the button is held. */
export const pressedHighlightNameOf = (name: string): string => `${name}-pressed`;

export const ALL_HOVER_HIGHLIGHT_NAMES = ALL_HIGHLIGHT_NAMES.flatMap((name) => [
  hoverHighlightNameOf(name),
  pressedHighlightNameOf(name)
]);
